// extracted by mini-css-extract-plugin
export default {"wrapper":"FaqCard_wrapper__jyaLx","container":"FaqCard_container__1CUqs","body":"FaqCard_body__5OOnE","title":"FaqCard_title__9hz81","description":"FaqCard_description__r8THC"};